import TreeItem, { treeItemClasses } from "@material-ui/lab/TreeItem/TreeItem";
import TreeView from "@material-ui/lab/TreeView/TreeView";
import Collapse from "@mui/material/Collapse";
import SvgIcon from "@mui/material/SvgIcon";
import { alpha, styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import * as React from "react";
// web.cjs is required for IE11 support
// import { useSpring, animated } from "@react-spring/web";
import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg';
import AlertDialog from "components/Dialog";
import Loader from "components/loader/Loader";
import { useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import { MyCheckbox } from "../../../components";

function MinusSquare(props) {
    return (
        <SvgIcon fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
            {/* tslint:disable-next-line: max-line-length */}
            <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 11.023h-11.826q-.375 0-.669.281t-.294.682v0q0 .401.294 .682t.669.281h11.826q.375 0 .669-.281t.294-.682v0q0-.401-.294-.682t-.669-.281z" />
        </SvgIcon>
    );
}

function PlusSquare(props) {
    return (
        <SvgIcon fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
            {/* tslint:disable-next-line: max-line-length */}
            <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 12.977h-4.923v4.896q0 .401-.281.682t-.682.281v0q-.375 0-.669-.281t-.294-.682v-4.896h-4.923q-.401 0-.682-.294t-.281-.669v0q0-.401.281-.682t.682-.281h4.923v-4.896q0-.401.294-.682t.669-.281v0q.401 0 .682.281t.281.682v4.896h4.923q.401 0 .682.281t.281.682v0q0 .375-.281.669t-.682.294z" />
        </SvgIcon>
    );
}

function CloseSquare(props) {
    return (
        <SvgIcon
            className="close"
            fontSize="inherit"
            style={{ width: 14, height: 14 }}
            {...props}
        >
            {/* tslint:disable-next-line: max-line-length */}
            <path d="M17.485 17.512q-.281.281-.682.281t-.696-.268l-4.12-4.147-4.12 4.147q-.294.268-.696.268t-.682-.281-.281-.682.294-.669l4.12-4.147-4.12-4.147q-.294-.268-.294-.669t.281-.682.682-.281.696 .268l4.12 4.147 4.12-4.147q.294-.268.696-.268t.682.281 .281.669-.294.682l-4.12 4.147 4.12 4.147q.294.268 .294.669t-.281.682zM22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0z" />
        </SvgIcon>
    );
}

function TransitionComponent(props) {
    //   const style = useSpring({
    //     from: {
    //       opacity: 0,
    //       transform: "translate3d(20px,0,0)",
    //     },
    //     to: {
    //       opacity: props.in ? 1 : 0,
    //       transform: `translate3d(${props.in ? 0 : 20}px,0,0)`,
    //     },
    //   });

    return (
        // <animated.div style={style}>
        <div>
            <Collapse {...props} />
        </div>
        // {/* </animated.div> */ }
    );
}

TransitionComponent.propTypes = {
    /**
     * Show the component; triggers the enter or exit states
     */
    in: PropTypes.bool,
};

const StyledTreeItem = styled((props) => (
    <TreeItem {...props} TransitionComponent={TransitionComponent} />
))(({ theme }) => ({
    [`& .${treeItemClasses}`]: {
        "& .close": {
            opacity: 0.3,
        },
    },
    [`& .${treeItemClasses}`]: {
        marginLeft: 15,
        paddingLeft: 18,
        borderLeft: `1px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
    },
}));

export default function Tree({
    btnText,
    disableAddNew,
    setAddNew,
    setDaisableAddNew,
    getLedgerType,
    setEdit,
    setDisable,
    chargeTypeTree,
    treeData,
    formik,
    getTypeID,
    addPath,
    selected,
    setSelected,
    selectedSubLedger,
    setSelectedSubLedger
}) {
    const { push } = useHistory();
    const location = useLocation();
    const [Id, setId] = useState();
    const [openDisableAlert, setOpenDisableAlert] = useState(false);
    const handleCloseDialog = () => {
        setOpenDisableAlert(false);
    };
    const handleCancel = (e) => {
        setOpenDisableAlert(false);
        e.preventDefault();
        push({
            pathname: location.pathname.replace("edit", "view"),
        });
    };
    const addNew = (e) => {
        e.preventDefault();
        setAddNew(true);
        setDaisableAddNew(true);
        setDisable(true);
        push({
            pathname: "/financial-setting/ledger-accounts/edit",
        });
    };
    const onTypeClick = (name, sub, id,subLedger) => {
        if (location.pathname.includes("edit")) {
            setOpenDisableAlert(true);
        }
        if (!location.pathname.includes("edit")) {
            setSelectedSubLedger({});
            getTypeID(name, sub, id);
            setSelected(name);
            setId(id);
        }
        if(subLedger?.length) return;
        if(window.scrollY > 280) {
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }
    };

    if (treeData) {
        return (
            <div className="pl-5">
                <AlertDialog
                    open={openDisableAlert}
                    handleClose={handleCloseDialog}
                    onDecline={() => {
                        setOpenDisableAlert(false);
                    }}
                    onAccept={handleCancel}
                    title={"Are you sure?"}
                    description={"Do you want to discard the changes you made?"}
                />
                <div className="charge-tree-button">
                    {disableAddNew === true ? (
                        <Link
                            type="button"
                            className={
                                chargeTypeTree !== undefined && chargeTypeTree
                                    ? "btn  btn-primary leftmenu-btn mb-3 mt-5"
                                    : "btn  btn-primary leftmenu-btn mb-3 ml-5 mt-5"
                            }
                            onClick={addNew}
                            disabled
                        >
                            <PlusIcon /> {btnText}
                        </Link>
                    ) : (
                        <Link
                            type="button"
                            className={
                                chargeTypeTree !== undefined && chargeTypeTree
                                    ? "btn btn-primary leftmenu-btn mb-3  mt-5"
                                    : "btn btn-primary leftmenu-btn mb-3 ml-5 mt-5"
                            }
                            onClick={addNew}
                        >
                            <PlusIcon /> {btnText}
                        </Link>
                    )}
                    {chargeTypeTree !== undefined && chargeTypeTree ? (
                        <div className="mt-3 setting-actions mr-5">
                            <a style={{ color: "#2555EF" }}>
                                <span className="mr-2">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="14"
                                        height="14"
                                        fill="currentColor"
                                        class="bi bi-box-arrow-right"
                                        viewBox="0 0 16 16"
                                    >
                                        <path
                                            fill-rule="evenodd"
                                            d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0v2z"
                                        />
                                        <path
                                            fill-rule="evenodd"
                                            d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z"
                                        />
                                    </svg>
                                </span>
                                Export List
                            </a>
                        </div>
                    ) : (
                        ""
                    )}
                </div>

                {chargeTypeTree !== undefined && chargeTypeTree ? (
                    <>
                        <div className="mt-5 mb-7 checkbox-charge-type">
                            <MyCheckbox
                                style={{
                                    backgroundColor: "black",
                                }}
                                name={`Show Archived`}
                                title="Show Archived"
                                handlechange={(event) => {
                                    formik.setFieldValue("show_archived", event.target.checked);
                                }}
                                checked={formik.values?.show_archived}
                                value={formik.values?.show_archived}
                                className=""
                            />
                        </div>
                        <div className="charge-expand-collapse mr-2 mb-5">
                            <a className="mr-4" style={{ color: "#2555EF" }}>
                                <span className="mr-2">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="12"
                                        height="12"
                                        fill="currentColor"
                                        class="bi bi-plus-square"
                                        viewBox="0 0 16 16"
                                    >
                                        <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" />
                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                                    </svg>
                                </span>
                                Expand All{" "}
                            </a>
                            <a className="mr-3" style={{ color: "#2555EF" }}>
                                <span className="mr-2">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="12"
                                        height="12"
                                        fill="currentColor"
                                        class="bi bi-dash-square"
                                        viewBox="0 0 16 16"
                                    >
                                        <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" />
                                        <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
                                    </svg>
                                </span>
                                Collapse All{" "}
                            </a>
                        </div>
                    </>
                ) : (
                    ""
                )}

                {
                    console.log("treedata", selected)
                }

                {treeData &&
                    <TreeView
                        // aria-label="customized"
                        aria-label="file system navigator"
                        // defaultExpanded={["1"]}
                        defaultCollapseIcon={<MinusSquare />}
                        defaultExpandIcon={<PlusSquare />}
                        defaultEndIcon={<CloseSquare />}
                        sx={{ height: 264, flexGrow: 1, maxWidth: 400, overflowY: "auto" }}
                        className="tree-view__list"
                    >
                        {treeData &&
                            treeData?.map((item, index) => (
                                <TreeItem
                                    key={item?._id}
                                    className={
                                        (!disableAddNew && selected === item?.ledger_name && Id === item?._id)
                                            ? selectedSubLedger?._id ? "type-select legder-menu" : "type-select type-select-bold legder-menu" : "legder-menu"
                                    }
                                    nodeId={item?._id}
                                    label={item?.ledger_name}
                                    onLabelClick={(event) => {
                                        event.stopPropagation()
                                        onTypeClick(item?.ledger_name, "ledger", item?._id,item?.sub_ledgers)
                                    }} 
                                    
                                >
                                    <div className="pl-5 ml-5">
                                        {item?.sub_ledgers?.length > 0 && item?.sub_ledgers ? (
                                            item?.sub_ledgers?.map((child) => (
                                                <div>
                                                    <div
                                                        className={`legder-sub-menu ${(!disableAddNew && selectedSubLedger?._id === child?._id) ? "subtype-select" : ""}`}
                                                        onClick={() => {
                                                            if (location.pathname.includes("edit")) {
                                                                setOpenDisableAlert(true);
                                                            }
                                                            if (!location.pathname.includes("edit")) {
                                                                setSelectedSubLedger(child);
                                                                setSelected(item?.ledger_name);
                                                                setId(item?._id);
                                                                getTypeID(
                                                                    child?.sub_ledger_name,
                                                                    "subLedger",
                                                                    child?._id
                                                                );
                                                            }
                                                            if(window.scrollY > 280) {
                                                                window.scrollTo({
                                                                    top: 0,
                                                                    behavior: "smooth"
                                                                });
                                                            }
                                                        }}
                                                    >
                                                        {child?.sub_ledger_name}
                                                    </div>
                                                    {/* <div>
                        {item?.sub_ledgers?.length - 1 === i ? (
                          <input value={formik.values?.ledger_name ?? ""}></input>
                        ) : (
                          ""
                        )}
                      </div> */}
                                                </div>
                                            ))
                                        ) : (
                                            <></>
                                        )}
                                    </div>
                                </TreeItem>
                            ))}
                    </TreeView>
                }
            </div>
        );
    }
    else {
        return (
            <Loader />
        )
    }

}
